import { render } from "./ViewInputForm.vue?vue&type=template&id=50f11eb3&scoped=true"
import script from "./ViewInputForm.vue?vue&type=script&lang=js"
export * from "./ViewInputForm.vue?vue&type=script&lang=js"

import "./ViewInputForm.vue?vue&type=style&index=0&id=50f11eb3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f11eb3"]])

export default __exports__